import React, { useState, useEffect } from 'react';
import { FaHome, FaUserEdit, FaCertificate, FaCalendarCheck, FaTicketAlt, FaSignOutAlt, FaTimes } from 'react-icons/fa';
import { Routes, Route, useLocation } from 'react-router-dom';
import { NavLink } from 'react-router-dom';
import Cookies from "js-cookie";

import Navbar from '../Navbar';
import ProfileCard from '../Profile/Profile_Card';
import ProfileEdit from '../Profile/Profile_Edit';
import CertificateSection from './Certificates';
import EventBookings from './EventBookings';

const Backdrop = ({ isPanelOpen, onClose }) => {
  return <div className={`backdrop ${isPanelOpen ? 'is-visible' : ''}`} onClick={onClose} />;
};

const LeftPanel = ({ isOpen, onClose, handleLogout }) => {
  return (
    // CLEANUP: Removed 'lp-closed' as it's not needed. The absence of 'is-open' is enough.
    <aside className={`left-panel ${isOpen ? 'is-open' : ''}`}>
      <div className="panel-header">
        <h3 className="panel-title">Dashboard</h3>
        <button onClick={onClose} className="close-panel-btn" aria-label="Close menu">
          <FaTimes />
        </button>
      </div>
      <nav className="menu-items">
        {/* Changed Home to Profile Card to match what's being rendered */}
        <NavLink to="/dashboard" end className={({ isActive }) => (isActive ? 'menu-item is-active' : 'menu-item')} onClick={onClose}>
          <FaHome className="menu-icon" />
          <span className='menu-label'>Profile Card</span>
        </NavLink>
        <NavLink to="/dashboard/profileEdit" className={({ isActive }) => (isActive ? 'menu-item is-active' : 'menu-item')} onClick={onClose}>
          <FaUserEdit className="menu-icon" />
          <span className='menu-label'>Edit Profile</span>
        </NavLink>
        <NavLink to="/dashboard/certificates" className={({ isActive }) => (isActive ? 'menu-item is-active' : 'menu-item')} onClick={onClose}>
          <FaCertificate className="menu-icon" />
          <span className='menu-label'>Certificates</span>
        </NavLink>
        <NavLink to="/dashboard/events-booked" className={({ isActive }) => (isActive ? 'menu-item is-active' : 'menu-item')} onClick={onClose}>
          <FaTicketAlt className="menu-icon" />
          <span className='menu-label'>Events Booked</span>
        </NavLink>
        <button className="menu-item menu-item--logout" onClick={handleLogout}>
          <FaSignOutAlt className="menu-icon" />
          <span className='menu-label'>Log Out</span>
        </button>
      </nav>
    </aside>
  );
};

export default function DashboardLayout() {
  // --- FIX #1: Corrected initial state logic ---
  // Panel should be OPEN on desktop (> 1024px) and CLOSED on mobile by default.
  const [isPanelOpen, setPanelOpen] = useState(window.innerWidth > 1024);
  const location = useLocation();

  useEffect(() => {
    // This effect ensures that on navigation, the panel closes on smaller screens.
    if (window.innerWidth <= 1024) {
      setPanelOpen(false);
    }
  }, [location.pathname]);
  
  const handleLogout = () => {
    Cookies.remove("email", { path: '/' });
    window.location.href = "/Login";
  };

  return (
    <div className={`dashboard-container ${isPanelOpen ? 'panel-is-open' : ''}`}>
      <Navbar onTogglePanel={() => setPanelOpen(o => !o)} />
      <Backdrop isPanelOpen={isPanelOpen} onClose={() => setPanelOpen(false)} />
      <LeftPanel isOpen={isPanelOpen} onClose={() => setPanelOpen(false)} handleLogout={handleLogout} />
      <main className="main-content-area">
        {/* Removed the extra content-header as it was not in your final code */}
        <div className="content-body">
          <Routes>
            <Route index element={<ProfileCard />} />
            <Route path="profileEdit" element={<ProfileEdit />} />
            <Route path="certificates" element={<CertificateSection />} />
            <Route path="events-booked" element={<EventBookings />} />
          </Routes>
        </div>
      </main>
    </div>
  );
}